import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Adds .in to .reveal elements as they scroll into view.
// Re-scans on every route change so sub-pages animate too.
export default function ScrollReveal() {
  const { pathname } = useLocation();

  useEffect(() => {
    const els = Array.from(document.querySelectorAll(".reveal"));
    // Reset (so revisiting a page re-animates)
    els.forEach((el) => el.classList.remove("in"));

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("in");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12 }
    );

    // Small delay so the new page's DOM is mounted
    const t = setTimeout(() => {
      document.querySelectorAll(".reveal").forEach((el) => io.observe(el));
    }, 40);

    return () => {
      clearTimeout(t);
      io.disconnect();
    };
  }, [pathname]);

  return null;
}
